import { useMutation } from '@apollo/client/react';
import { Button } from 'components/ui';
import { useInfo } from 'contexts/info';
import { useError } from 'contexts/error';
import { FormattedMessage } from 'react-intl';
import DeleteMutation from 'mutations/space/delete_permission';
import Confimation from 'components/form/confirmation';

const DeleteButton = ({ permission, onSuccess }) => {
  const setInfo = useInfo();
  const setError = useError();

  const [deleteMutation, deleteMutationData] = useMutation(DeleteMutation, {
    onCompleted: () => {
      setInfo('info.user.deleted');
      onSuccess();
    },
    onError: () => {
      setError('error.user.delete');
    },
  });
  return (
    <Confimation
      title={<FormattedMessage id="header.user.delete" />}
      description={<FormattedMessage id="confirmation.user.delete" />}
      onClick={() => {
        deleteMutation({ variables: { id: permission.user.id } });
      }}
    >
      <Button color="error" variant="outlined" size="small" disabled={deleteMutationData.loading}>
        <FormattedMessage id="button.delete" />
      </Button>
    </Confimation>
  );
};

export default DeleteButton;
